import { createAction } from '@reduxjs/toolkit';

export const REMOVE_ORDER_CARD = 'REMOVE_ORDER_CARD';

export const removeOrderCard = createAction(
    REMOVE_ORDER_CARD,
    () => ({ payload: {} }),
);
